import moment from 'jalali-moment';
import ReactPaginate from 'react-paginate';
import endpoints from '../../config/endpoints';
import { Sidebar } from "../../layouts/Sidebar";
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Tabs from '../../layouts/Tabs';
import { setLoading } from '../../services/reducers/homeSlice';
import restApi from '../../services/restApi';
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import tools from '../../utils/tools';

const Variant = () => {
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [query, setQuery] = useState('');
  const [itemOffset, setItemOffset] = useState(0);
  const [tab, setTab] = useState('all');
  const itemsPerPage = 25;
  const endOffset = itemOffset + itemsPerPage;
  let currentItems = data.filter(e => e?.product != null && e.product?.title?.toLowerCase()?.includes(query.toLowerCase()))?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(data.length / itemsPerPage);

  const tabTitles = {
    all: { title: 'همه', count: data.length },
    active: { title: 'فعال', count: data.filter(e => e.isActive)?.length },
    unActive: { title: 'غیرفعال', count: data.filter(e => !e.isActive)?.length },
  }

  const deleteItem = async (id: number) => {
    if(confirm('آیا مطمئن هستید؟')){
      dispatch(setLoading(true));
      
      const res = await restApi(endpoints.variant.index + id, true).delete({});
      
      if(res.code == 204){
        Swal.fire({
          title: 'موفق',
          text: ' قیمت  با موفقیت حذف شد',
          icon: 'success',
          confirmButtonText: 'متوجه شدم'
        })
      } else {
        Swal.fire({
          title: 'ناموفق',
          text: res?.data,
          icon: 'error',
          confirmButtonText: 'متوجه شدم'
        })
      }
      
      dispatch(setLoading(false));
      fetchData()
    }
  }
  const list = () => {
    const rows = [];

    currentItems.filter(e => {
      switch (tab){
        case('active'): return e.isActive;
        case('unActive'): return !e.isActive;
        default: return e;
      }
    }).map((variant: any, index) => {
      rows.push(
        <tr className="">
          <td className="svgContainer">
            <i className="eye"></i>
            <i className="trash clickable" onClick={() => deleteItem(variant.id) }></i>
            <a href={`/variant/edit/${variant.id}`}><i className="edit clickable"></i></a>
          </td>
          <td className="">{moment(variant.createdAt).add(variant.validTime, 'h').format('jYYYY/jMM/jDD HH:MM')}</td>
          <td className="">{tools.formatPrice(variant.sellPrice)}</td>
          <td className="">{variant.product?.title}</td>
          <td>{++index}</td>
        </tr>
      )
    })
    
    return rows;
  };
  
  const fetchData = async () => {
    dispatch(setLoading(true));
    
    const res = await restApi(endpoints.variant.index, true).get();

    if(res.code == 200){
      setData(res.data.filter(e => e.validTime));
    }
    
    dispatch(setLoading(false));
  };
  
  useEffect(() => {
    fetchData();
  }, []);
  
  return(
    
    <>
      <body className="dashboardBody">
      <Sidebar />
      <main className="dashBoardMain">
        <h1 className="dashBoardTitle">لیست قیمت ها</h1>
        <Tabs tabTitles={tabTitles} tab={tab} setTab={setTab}/>
        <div className="searchContainer">
          <span className="dashboardHeader clickable"  onClick={() => navigate('/variant/add')}>
            <p>افزودن قیمت جدید</p>
            <i className="addPlus"></i>
          </span>
          <div className="dashboardseaechBox">
            <i className="dashMagnifierIcon"></i>
            <input className="dashSearchInput" placeholder="جستجو" onChange={(input:any) => setQuery(input.target.value)}></input>
          </div>
        </div>
        <table className="listTable">
          <thead>
          <tr className="firstTR">
            <th>عملیات</th>
            <th>تاریخ انقضا</th>
            <th>قیمت</th>
            <th>عنوان</th>
            <th>ردیف</th>
          </tr>
          </thead>
          <tbody>
          {list()}
          </tbody>
        </table>
        <ReactPaginate
          breakLabel="..."
          nextLabel="بعدی >"
          onPageChange={(event) => setItemOffset((event.selected * itemsPerPage) % data.length)}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="< قبلی"
          renderOnZeroPageCount={null}
          className="pagination"
          pageClassName="paginationBreak"
          previousClassName="paginationBreak"
          nextClassName="paginationBreak"
          activeClassName="paginationActive"
        />
      </main>
      </body>
    </>
  )
}
export default Variant;